<template>
   <img :src="image_source" :id="`carousel-image-${index}`" class="carousel-image" />
</template>

<script>
export default {
   props: {
      index: Number,
      image_source: String,
   },
};
</script>

<style lang="scss" scoped>
.carousel-image {
   max-height: 90vh;
   max-width: 90vw;
   object-fit: contain;
   margin: auto;
}
</style>

